const RemoveNullsFromResponse = function(_key, value) {
  if (value !== null) return value
}

export { RemoveNullsFromResponse }